/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '@app/config';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { EVENTS, trackEvent } from '@app/segment';

const Help = () => {
  const { t } = useTranslation();
  const urlPrefix = useUrlPrefix();

  return (
    <li key="faq">
      <a
        data-testid="navbar-menu-help"
        href={`${config.APP.HELP_PAGE_URL}${urlPrefix}`}
        target="_blank"
        rel="noopener"
        onClick={() => {
          trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
            label: t('Help'),
          });
        }}
      >
        {t('Help')}
      </a>
    </li>
  );
};

export default Help;
